import styled from 'styled-components';

import Button from '@components/Button';
import CustomIcon from '@components/utils/CustomIcon';
import { ArrowLeftSLine4 } from '@assets/icons';
import { ButtonProps } from '@components/Button/ButtonInterface';

const FilterSortButton = styled(Button)`
  &&& {
    border-radius: 4px !important;
    background-color: ${({ theme }) => theme.palette.grey200} !important;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 296px;
    margin: 0px auto;

    &:hover,
    &:active {
      background-color: ${({ theme }) => theme.palette.grey400} !important;
    }
  }
`;

const ResponsiveListingFilterButtonLabel = styled.span`
  color: ${({ theme }) => theme.palette.grey1100};
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`;

const ResponsiveFilterSortButton = ({
  title = 'Filtrele ve Sırala',
  onClick,
  ...otherButtonProps
}: ButtonProps) => (
  <FilterSortButton onClick={onClick} {...otherButtonProps}>
    <CustomIcon paletteColor='grey1100' fontSize={16} icon={ArrowLeftSLine4} />
    <ResponsiveListingFilterButtonLabel>
      {title}
    </ResponsiveListingFilterButtonLabel>
  </FilterSortButton>
);

export default ResponsiveFilterSortButton;
